<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <CreditCardDialog v-if="showUpdateCcDialog" v-model="showUpdateCcDialog"></CreditCardDialog>

    <v-dialog v-model="show" max-width="500px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card v-if="!!payment_info && addOns">
        <v-card-title>
          <h2>Purchase</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0 text-xs-left" v-for="(addOn, index) in addOns" :key="index">

          <div class="mb-2"><b>{{ addOn.name }}:</b> {{ addOn.description }}</div>



          <!-- monthly amount row -->
<!--          <v-layout align-center row wrap v-if="!yearly">-->
<!--            <span class="txt-bold">Monthly subscription:&nbsp;</span>-->
<!--            <span class="txt-bold">${{ formatPrice(addOn.monthly) }}</span>-->
<!--            <span class="txt-bold"-->
<!--                  style="font-size: 7pt;">&nbsp;/ mo</span>-->
<!--          </v-layout>-->
          <!-- yearly amount row -->
<!--          <v-layout align-center row wrap v-if="yearly">-->
<!--            <span class="txt-bold">Annual subscription:&nbsp;</span>-->
<!--            <span class="txt-bold">${{ formatPrice(addOn.yearly) }}</span>-->
<!--            <span class="txt-bold"-->
<!--                  style="font-size: 7pt;">&nbsp;/ year</span>-->
<!--          </v-layout>-->

          <!--    todo: make sure this wording and prices are correct      -->
          <div v-if="payment_info.last_four">
            <div class="mt-2" >
              <span v-if="addOn.inCart === 'monthly' && addOn.monthly">Your card ending in {{ payment_info.last_four }} will be charged {{  addOn.price > 0  ? `$${formatPrice(addOn.price)}` : '$0.00' }} today</span>
              <span v-if="addOn.inCart === 'monthly' && addOn.monthly">{{ ` and $${formatPrice(addOn.monthly)} per month beginning on your next billing cycle.` }}</span>
              <span v-if="addOn.inCart === 'monthly' && addOn.monthly">&nbsp;This will start your monthly subscription to {{ addOn.name }} premium content.</span>
              <span v-if="addOn.inCart === 'annually' && addOn.yearly">Your card ending in {{ payment_info.last_four }} will be charged {{  `$${formatPrice(addOn.yearly)}` }} today.</span>
              <span v-if="addOn.inCart === 'annually' && addOn.yearly">&nbsp;This will start your annual subscription to {{ addOn.name }} premium content.</span>
              <!--              <span v-if="yearly">{{ ` and $${formatPrice(addOn.yearly)} twelve months from now` }}</span>-->
            </div>
          </div>

        </v-card-text>

        <!-- amount due today row -->
        <v-card-text class="pt-0 text-xs-left">
          <v-layout align-center row wrap>
            <span class="txt-bold">Amount due today:&nbsp;</span>
            <span class="txt-bold">${{ formatPrice(totalDue) }}</span>
          </v-layout>
        </v-card-text>

        <!--    todo: make sure this wording and prices are correct      -->
        <div v-if="payment_info.last_four">
          <v-layout justify-center wrap class="mt-2">
            <v-btn round color="primary" @click="submitAddOnPurchase">Confirm</v-btn>
          </v-layout>
        </div>

        <div v-if="!payment_info.last_four">
          <v-layout justify-center wrap class="mt-2">
            <v-btn round color="primary" @click="addPaymentMethod">Add Payment Method</v-btn>
          </v-layout>
        </div>

      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import api from "../../../services/api_endpoints"
  import store from "../../../store"
  import LoadingDialog from "../../LoadingDialog"
  import CreditCardDialog from "../paymentInformationCard/CreditCardDialog"

  export default {
    components: {
      CreditCardDialog,
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      showUpdateCcDialog: false,
      payment_info: store.state.ccInfo,
      snackbar: {
        success: false,
        error: false,
        timeout: 2000,
        errorMessage: "An unknown error occurred",
        successMessage: "Add-on purchase successful"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      onClose: {
        type: Function,
        default: ()=> ({})
      },
      yearly: {
        type: Boolean,
        default: false
      },
      addOns: {
        type: Array,
        default: () => ([{
          name: '',
          price: 0,
          monthly: 0,
          description: ''
        }])
      },
      totalDue: {
        type: Number,
        default: 0
      }
    },
    mounted() {
      // subscribe to changes on the 'setUser' store mutation
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setCcInfo') {
          this.payment_info = state.ccInfo
        }
      })
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async submitAddOnPurchase() {

        this.showLoadingDialog = true;
        let response = await api.submitAddOnPurchase(this.addOns);
        this.showLoadingDialog = false;

        if (response.success) {
          this.snackbar.success = true;
          this.show = false
        } else {
          this.snackbar.error = true
        }
        if (this.isFunction(this.onClose)) this.onClose(response.success)
      },
      async addPaymentMethod() {
        this.showUpdateCcDialog = true;
      },
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
